import { action } from 'src/store/actions';

/* Customer Addresses */
export const FETCH_CUSTOMER_ADDRESSES = 'FETCH_CUSTOMER_ADDRESSES';
export const REQUEST_CUSTOMER_ADDRESSES = 'REQUEST_CUSTOMER_ADDRESSES';
export const SUCCESS_CUSTOMER_ADDRESSES = 'SUCCESS_CUSTOMER_ADDRESSES';
export const FAILURE_CUSTOMER_ADDRESSES = 'FAILURE_CUSTOMER_ADDRESSES';

export const fetchCustomerAddresses = () => action(FETCH_CUSTOMER_ADDRESSES);
export const requestCustomerAddresses = () => action(REQUEST_CUSTOMER_ADDRESSES);
export const requestCustomerAddressesSuccess = (response: any) => action(SUCCESS_CUSTOMER_ADDRESSES, { response });
export const requestCustomerAddressesFailure = (error: any) => action(FAILURE_CUSTOMER_ADDRESSES, { error });
